import { render, staticRenderFns } from "./ServiceProviders.vue?vue&type=template&id=4681c1fc&scoped=true&"
import script from "./ServiceProviders.vue?vue&type=script&lang=js&"
export * from "./ServiceProviders.vue?vue&type=script&lang=js&"
import style0 from "./ServiceProviders.vue?vue&type=style&index=0&id=4681c1fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4681c1fc",
  null
  
)

export default component.exports